import { defineComponent as _defineComponent } from 'vue'
import { unref as _unref, createVNode as _createVNode, normalizeStyle as _normalizeStyle, createElementVNode as _createElementVNode, toDisplayString as _toDisplayString, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, normalizeClass as _normalizeClass } from "vue"

const _hoisted_1 = { class: "relative flex flex-col-reverse w-full h-full items-end" }
const _hoisted_2 = { class: "flex h-6 w-6" }
const _hoisted_3 = /*#__PURE__*/_createElementVNode("span", { class: "animate-ping absolute inline-flex h-6 w-6 rounded-full bg-red-400 opacity-50" }, [
  /*#__PURE__*/_createElementVNode("span", { class: "" })
], -1)
const _hoisted_4 = { class: "relative inline-flex rounded-full h-6 w-6 bg-red-500 items-center text-center justify-center" }
const _hoisted_5 = { class: "text-white text-xs p-1" }

import { computed, watch, ref, onMounted } from 'vue'
    import { useTitle, useDraggable } from '@vueuse/core'
    import { useUsersStore } from '@/stores/users'
    import { useChatStore } from '@/stores/chat'
    import { useGroupsStore } from '@/stores/groups'

    import useChatInternal from '@/hooks/useChatInternal'
    import useWebSocketChat from '@/hooks/useWebSocketChat'
    import useMoveInterface from '@/hooks/useMoveInterface'

    import Icon from '@/components/Icon/IndexIcon.vue'
    // import { getWidthWindow, getHeightWindow } from '@/helpers/interface'

    
export default /*#__PURE__*/_defineComponent({
  __name: 'StandbyBox',
  props: {
        bgColor: { type: String, default: '#000' },
        right: { type: String, default: '20' }
    },
  emits: ['open-box'],
  setup(__props, { emit }) {

    

    

    const el = ref<HTMLElement | null>(null)

    const groupStore = useGroupsStore()
    const userStore = useUsersStore()
    const chatStore = useChatStore()

    const { getWidget, setWidget, verifyPositionOpenBox } = useMoveInterface()

    const countUnread = computed(() => userStore.countUnreadMessage + groupStore.countUnreadMessage)
    const positionForClick = computed(() => getWidget())

    const { x, y } = useDraggable(el, { initialValue: { x: positionForClick.value.x, y: positionForClick.value.y } })
    const { read, typing, sendSuccess, receive, usersOnline, firstInstance, readSuccess } = useChatInternal()
    const { data } = useWebSocketChat()

    const handleClick = () => {
        if (positionForClick.value.x === x.value && positionForClick.value.y === y.value) {
            verifyPositionOpenBox()
            emit('open-box')
        }
    };

    function handleMousedown  (): void {
        setWidget({x: x.value, y: y.value})
    }

    /* function initialize(): void {
        if(positionForClick.value.x === 0 && positionForClick.value.y === 0) {
            x.value = 1
            y.value = 20
        }
    } */

    onMounted(() => {
        // initialize()
    }),
    /* watch(() => x.value, newValue => {
        if (newValue < 0) x.value = 1
        if ((newValue + 64) > getWidthWindow()) x.value = getWidthWindow() - 64
    })

    watch(() => y.value, newValue => {
        if (newValue < 0) y.value = 1
        if ((newValue + 64) > getHeightWindow()) y.value = getHeightWindow() - 64

    }) */

    watch(() => countUnread.value, newValue => {
        const count = newValue > 0 ? `(${newValue})` : ''
        useTitle(` ${count} Chat Interno`)
    })

    /*  watch(() => x.value, newValue => console.log(newValue))
    watch(() => y.value, newValue => console.log(newValue)) */
    watch(() => data.value, newValue => {
        const result = JSON.parse(newValue)
        const op = result.type
        const  id = result?.data?.group ?? result?.data?.submitted_by ?? null
        switch (op) {
            case 'success_send_message':
                sendSuccess(result.data)
                break

            case 'receive_message':
                const type = result.data.to_send === 'user' ? 'users' : 'groups'
                receive(result.data)
                if (type === 'users') {
                    userStore.upCountUnreadMessage(id, false)
                    userStore.upLastMessage(id)
                }
                if( type === 'groups'){
                    groupStore.upCountUnreadMessage(id, false)
                    groupStore.upLastMessage(id)
                }
                break

            case 'typing_messages':
                typing(result.data)
                break

            case 'read_messages':
                read(result.data.to_user, 'sent')
                break

            case 'users_online':
                usersOnline(result.data.users)
                break
            case 'success_read_messages':
                setTimeout(() => readSuccess(result.data), 1000)
                break;
            case 'connection':
                firstInstance(result.data.first)
                break;
            // default:
                // console.log(newValue)
        }
    }, { deep: true })

return (_ctx: any,_cache: any) => {
  return (_openBlock(), _createElementBlock("div", {
    class: _normalizeClass(["fixed bottom-1 h-16 w-16", [  _unref(chatStore).useLeft ? 'left-0' : 'right-3' ]])
  }, [
    _createElementVNode("div", _hoisted_1, [
      _createElementVNode("div", {
        onMousedown: handleMousedown,
        onClick: handleClick,
        style: _normalizeStyle({ 'background-color': __props.bgColor }),
        class: "flex-none rounded-full w-full h-full flex items-center justify-center cursor-pointer shadow-md"
      }, [
        _createVNode(Icon, {
          size: "14",
          name: "Chat",
          color: "white"
        })
      ], 36),
      (_unref(countUnread) > 0)
        ? (_openBlock(), _createElementBlock("div", {
            key: 0,
            onClick: handleClick,
            class: "absolute -right-1 -top-1 z-20"
          }, [
            _createElementVNode("div", _hoisted_2, [
              _hoisted_3,
              _createElementVNode("span", _hoisted_4, [
                _createElementVNode("span", _hoisted_5, _toDisplayString(_unref(countUnread)), 1)
              ])
            ])
          ]))
        : _createCommentVNode("", true)
    ])
  ], 2))
}
}

})